import React from 'react';
import './Hero.css';

function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Software de Gestión de los Servicios de Campo
            </h1>
            <p className="hero-subtitle">
              Ayudamos a empresas de servicio técnico a organizar su trabajo, ganar tiempo y facturar más.
            </p>
            <p className="hero-description">
              Organiza órdenes, técnicos, clientes y facturación desde un solo lugar
            </p>
            <div className="hero-buttons">
              <button className="btn btn-primary btn-large" onClick={scrollToContact}>
                Agendar Reunión Gratis
              </button>
              <button className="btn btn-secondary btn-large" onClick={scrollToContact}>
                Ver Demo
              </button>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">+30%</span>
                <span className="stat-label">Más trabajos</span>
              </div>
              <div className="stat">
                <span className="stat-number">-50%</span>
                <span className="stat-label">Menos tiempo</span>
              </div>
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">Organizado</span>
              </div>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-mockup">
              <div className="mockup-screen">
                <div className="mockup-header">
                  <div className="mockup-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div className="mockup-content">
                  <div className="mockup-card">
                    <div className="card-icon">📋</div>
                    <div className="card-text">Órdenes de Trabajo</div>
                  </div>
                  <div className="mockup-card">
                    <div className="card-icon">👷</div>
                    <div className="card-text">Gestión de Técnicos</div>
                  </div>
                  <div className="mockup-card">
                    <div className="card-icon">📊</div>
                    <div className="card-text">Reportes en Tiempo Real</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
